import React from "react";
import "./QuoteHero.css";

const QuoteHero: React.FC = () => {
  return (
    <section className="quote-section">
      <div className="container">
        <div className="quote-wrap">
          {/* LEFT IMAGE */}
          <div className="quote-img-wrap">
            <div className="quote-img-frame">
              <img src="/aji-image.jpeg" alt="Leadership" />
            </div>
            <div className="quote-img-badge">CEO · AJERA</div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="quote-body">
            <div className="quote-icon">"</div>
            <p className="quote-text">
              Companies will have a greater technology landscape, but we need
              to completely change the narrative to inspire people to paint the
              future. It is human in the lead, not human in the loop.
            </p>
            <div className="quote-divider" />
            <div className="quote-author-row">
              <div className="quote-author-dot" />
              <div>
                <p className="quote-author-name">Ajithya Ramavarman</p>
                <p className="quote-author-role">CEO, AJERA Infotech</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteHero;
